/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

M.Model = M.Model || {};

/**
 * @class M.Model.DatePicker
 *
 * Model for M.View.DatePicker
 *
 */
M.Model.DatePicker = Backbone.Model.extend({
  defaults: {
    selectedDay: null,
    selectedMonth: null,
    selectedYear: null,
    minYear: 1900,
    maxYear: new Date().getFullYear() + 5,
    showYear: true,
    shouldDisplayDateLabel: false,
    reverseYearOrder: false,
    defaultMonthToDays: {
      0: 31,
      1: 28,
      2: 31,
      3: 30,
      4: 31,
      5: 30,
      6: 31,
      7: 31,
      8: 30,
      9: 31,
      10: 30,
      11: 31
    },
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]
  },

  /**
   * Returns true if the current year is a leap year
   */
  isLeapYear: function() {
    return new Date(this.get('selectedYear'), 1, 29).getMonth() == 1;
  },

  /**
   * Returns the number of days for the currently selected month.
   * Defaults to January if no month is currently selected.
   * Returns 29 days if the current month is February and isLeapYear() is true
   */
  getDaysInMonth: function() {
    var selectedMonth = this.get('selectedMonth');
    var selectedYear = this.get('selectedYear');
    if (selectedMonth != null) {
      var daysInMonth = this.get('defaultMonthToDays')[selectedMonth];
    } else {
      // default to 31 days in January
      var daysInMonth = this.get('defaultMonthToDays')[0];
    }
    if (selectedYear && (selectedMonth > -1)) {
      var isLeapYear = this.isLeapYear();
      // months are zero based, so Feb == 1
      var isFebruary = selectedMonth == 1;
      if (isLeapYear && isFebruary) {
        daysInMonth = 29;
      }
    }
    return daysInMonth;
  },

  /**
   * Returns the currently selected values as JS Date object
   */
  getSelectedDate: function() {
    var year = this.get('selectedYear') ? this.get('selectedYear') : 1900;
    // Date() months are zero based
    var month = this.get('selectedMonth') ? this.get('selectedMonth') : 0;
    var day = this.get('selectedDay') ? this.get('selectedDay') : 1;
    var date = new Date(year, month, day);
    return date;
  },

  isDayAndMonthSelected: function() {
    var month = this.get('selectedMonth');
    var day = this.get('selectedDay');
    var monthSet = (month != null) && month > -1;
    var daySet = (day != null) && day > 0;

    return (monthSet && daySet);
  }

});
